import angular from 'angular';
import { saveAs } from 'file-saver/FileSaver';

let ClientListController = function (Client, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at',
      like_search: '',
      like_search_fields: [
        'email',
        'sabin_id',
        '$mobile_user.name$'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  $scope.downloadReport = function () {
    $ctrl.activeSpin = true;
    $ctrl.activeSpinButton = true;
    Client
    .downloadReport()
    .then(function (res) {
      let messageSuccess = $filter('translate')('report-success');
      $ctrl.activeSpin = false;
      $ctrl.activeSpinButton = false;
      Toast.success(messageSuccess);
      window.location.href = res.url;
    }).catch(err => {
      console.log('err:' ,  err);
      let messageError = $filter('translate')('report-error');
      $ctrl.activeSpin = false;
      $ctrl.activeSpinButton = false;
      Toast.error(messageError);
    });
  };

  $scope.downloadReportSmall = function () {
    $ctrl.activeSpinSmall = true;
    $ctrl.activeSpinSmallButton = true;
    Client
    .downloadReportSmall()
    .then(function (res) {
      let messageSuccess = $filter('translate')('report-success');
      $ctrl.activeSpinSmall = false;
      $ctrl.activeSpinSmallButton = false;
      Toast.success(messageSuccess);
      window.location.href = res.url;
    }).catch(err => {
      console.log('err:' ,  err);
      let messageError = $filter('translate')('report-error');
      $ctrl.activeSpinSmall = false;
      $ctrl.activeSpinSmallButton = false;
      Toast.error(messageError);
    });
  };

  function edit(id) {
    $state.go('client.edit', {id});
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Client
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

ClientListController.$inject = ['Client', '$filter', '$scope', '$state', 'Toast'];

export default ClientListController;



// WEBPACK FOOTER //
// ./client/app/components/client/client-list.controller.js